@keyframes fadeIn {
    from {
        opacity: 0.25;
    }
    to {
        opacity: 1;
    }
}

.days {
    all: unset;
    position: relative;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1px 1px 1px 1px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.06px;
    border-radius: 4px;
    user-select: none;
    border: 2px solid transparent;

    &[data-shape='rounded-left'] {
        border-top-left-radius: 14px;
        border-bottom-left-radius: 14px;
    }

    &[data-shape='rounded-right'] {
        border-top-right-radius: 14px;
        border-bottom-right-radius: 14px;
    }

    @media (max-width: 768px) {
        height: 40px;
        font-size: 15px;
    }

    @media (max-width: 480px) {
        height: 30px;
        font-size: 14px;
    }

    &[data-clickable='true'] {
        cursor: pointer;

        &:hover,
        &:focus-visible {
            box-shadow: 0 2px 6px var(--ax-bg-overlay);
            border-color: var(--ax-bg-overlay);
        }
    }

    &[data-clickable='false'] {
        cursor: default;
    }

    &[data-fade-in='true'] {
        @media (prefers-reduced-motion: no-preference) {
            animation: fadeIn 0.5s ease-in forwards;
        }
    }

    &[data-periode-color] {
        print-color-adjust: exact;
    }

    &[data-periode-color='BLUE'] {
        background-color: var(--ax-accent-400);
    }

    &[data-periode-color='DARKBLUE'] {
        background-color: var(--ax-bg-accent-strong-pressed);

        & span {
            color: var(--ax-text-accent-contrast);
        }
    }

    &[data-periode-color='LIGHTBLUE'] {
        background-color: var(--ax-accent-300);
        border-color: var(--ax-accent-500);
    }

    &[data-periode-color='LIGHTGREEN'] {
        background-color: var(--ax-success-400);
    }

    &[data-periode-color='GREEN'] {
        background-color: var(--ax-success-400);
    }

    &[data-periode-color='GREENSTRIPED'] {
        background: linear-gradient(
            45deg,
            var(--ax-success-400) 0%,
            var(--ax-success-400) 15%,
            var(--ax-bg-default) 15%,
            var(--ax-bg-default) 30%,
            var(--ax-success-400) 30%,
            var(--ax-success-400) 45%,
            var(--ax-bg-default) 45%,
            var(--ax-bg-default) 60%,
            var(--ax-success-400) 60%,
            var(--ax-success-400) 75%,
            var(--ax-bg-default) 75%,
            var(--ax-bg-default) 90%,
            var(--ax-success-400) 90%
        );
        border-color: var(--ax-success-500);
    }

    &[data-periode-color='BLUESTRIPED'] {
        background: linear-gradient(
            45deg,
            var(--ax-accent-400) 0%,
            var(--ax-accent-400) 15%,
            var(--ax-bg-default) 15%,
            var(--ax-bg-default) 30%,
            var(--ax-accent-400) 30%,
            var(--ax-accent-400) 45%,
            var(--ax-bg-default) 45%,
            var(--ax-bg-default) 60%,
            var(--ax-accent-400) 60%,
            var(--ax-accent-400) 75%,
            var(--ax-bg-default) 75%,
            var(--ax-bg-default) 90%,
            var(--ax-accent-400) 90%
        );
        border-color: var(--ax-accent-500);
    }

    &[data-periode-color='GRAY'] {
        background-color: var(--ax-neutral-100);
    }

    &[data-periode-color='DARKGRAY'] {
        background-color: var(--ax-neutral-400);
    }

    &[data-periode-color='BLACK'] {
        background-color: var(--ax-bg-neutral-strong);

        & span {
            color: var(--ax-text-neutral-contrast);
        }
    }

    &[data-periode-color='BLACKOUTLINE'] {
        border-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='BLUEOUTLINE'] {
        border-color: var(--ax-accent-500);
    }

    &[data-periode-color='BEIGEOUTLINE'] {
        border-color: var(--ax-brand-beige-600);
    }

    &[data-periode-color='GREEN_WITH_BLACK_OUTLINE'] {
        background-color: var(--ax-success-400);
        border-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='BLUE_WITH_BLACK_OUTLINE'] {
        background-color: var(--ax-accent-400);
        border-color: var(--ax-bg-neutral-strong);
    }

    &[data-periode-color='GREENOUTLINE'] {
        border-color: var(--ax-success-400);
    }

    &[data-periode-color='LIGHTGREENBLUE'] {
        background: linear-gradient(
            to top,
            var(--ax-accent-400),
            var(--ax-accent-400) 50%,
            var(--ax-success-200) 50%,
            var(--ax-success-200) 100%
        );
        border-color: var(--ax-accent-400);
    }

    &[data-periode-color='LIGHTBLUEGREEN'] {
        background: linear-gradient(
            to top,
            var(--ax-success-400),
            var(--ax-success-400) 50%,
            var(--ax-accent-300) 50%,
            var(--ax-accent-300) 100%
        );
        border-color: var(--ax-success-400);
    }

    &[data-hover-preview='true'] {
        background-color: var(--ax-accent-600);
    }
}

.icon {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 12px;
    height: 12px;
    pointer-events: none;
}
